import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import React from "react";
interface ScheduleDetailsTabProps {
  scheduleId: string;
  data: any;
}
export const ScheduleDetailsTab: React.FC<ScheduleDetailsTabProps> = ({
  scheduleId,
  data,
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="page-title mb-2">Trigger Conditions</CardTitle>
          <p className="page-subtitle mb-2">
            Schedule execution rules and frequency
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
              <span className="font-medium text-blue-900">
                {data?.frequencyTypeDisplay} Schedule
              </span>
            </div>
            <p className="text-blue-800">{data?.scheduleTypeDisplay}</p>
            <p className="text-sm text-blue-600 mt-1">
              Next execution: {data?.nextExecutionDate}
            </p>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="page-title mb-2">Work Order Template</CardTitle>
          <p className="page-subtitle mb-2">
            Default settings for generated work orders
          </p>
        </CardHeader>
        {Array.isArray(data?.sopDetails) && data.sopDetails.length > 0 ? (
          data.sopDetails.map((sop, index) => (
            <Card key={index} className="mb-4">
              <CardContent className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Default Priority
                    </label>
                    <Badge
                      variant="secondary"
                      className="bg-yellow-100 text-yellow-800 mt-1"
                    >
                      {sop.priorityDisplay ?? "Medium"}
                    </Badge>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Estimated Duration
                    </label>
                    <p className="text-gray-900 font-medium mt-1">
                      {sop.taskTimeCount ?? "N/A"}
                    </p>
                  </div>
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-500 mb-3 block">
                    Linked Standard Operating Procedures
                  </label>

                  <div className="space-y-3">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="outline"
                              className="bg-blue-100 text-blue-800"
                            >
                              {sop.serviceNo ?? "N/A"}
                            </Badge>
                            <span className="font-medium text-blue-900">
                              {sop.name ?? "Untitled SOP"}
                            </span>
                          </div>

                          <p className="text-sm text-blue-800 mb-2">
                            {sop.description ??
                              "No description available for this SOP."}
                          </p>

                          <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                              <span className="text-blue-600 font-medium">
                                Service Association:
                              </span>
                              <span className="text-blue-800 ml-1">
                                {sop.serviceAssociationDisplay ?? "N/A"}
                              </span>
                            </div>
                            <div>
                              <span className="text-blue-600 font-medium">
                                Operation Type:
                              </span>
                              <span className="text-blue-800 ml-1">
                                {sop.operationTypeDisplay ?? "N/A"}
                              </span>
                            </div>
                            <div>
                              <span className="text-blue-600 font-medium">
                                Tasks:
                              </span>
                              <span className="text-blue-800 ml-1">
                                {sop.taskCount
                                  ? `${sop.taskCount} Tasks`
                                  : "N/A"}
                              </span>
                            </div>
                            <div>
                              <span className="text-blue-600 font-medium">
                                Est. Duration:
                              </span>
                              <span className="text-blue-800 ml-1">
                                {sop.taskTimeCount ?? "N/A"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        ) : (
          <div className="bg-gray-50 border border-gray-200 rounded-lg py-6 text-center text-gray-500">
            No Work Order Template Available.
          </div>
        )}
      </Card>

      {/* <Card>
       */}
      {/* <Card>
        <CardHeader>
          <CardTitle className="page-title mb-2">Asset Inclusion</CardTitle>
          <p className="page-subtitle mb-2">
            Asset inclusion and dynamic scheduling settings
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-4 bg-green-50 border border-green-200 rounded-lg">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                <span className="font-medium text-green-900">
                  Dynamic Asset Inclusion
                </span>
              </div>
              <p className="text-sm text-green-800">
                New assets matching the criteria will be automatically included
              </p>
            </div>
            <Badge variant="secondary" className="bg-green-100 text-green-800">
              {data?.dynamicAssetInclusion ? "Active" : "Inactive"}
            </Badge>
          </div>
          <div className="text-sm text-gray-600">
            <p>
              <strong>Matching Criteria:</strong> Assets with the same asset
              type, location, or system as currently selected assets will be
              automatically added to this schedule when created in the system.
            </p>
          </div>
        </CardContent>
      </Card> */}
      {/* Removed for now will need after */}

      {/* Assignment & Generation Section */}
      <Card>
        <CardHeader>
          <CardTitle className="page-title mb-2">
            Assignment & Generation Rules
          </CardTitle>
          <p className="page-subtitle mb-2">
            Workflow automation and assignment logic
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-500 mb-2 block">
              Assignment Guidelines
            </label>
            <div className="flex flex-wrap gap-2">
              <Badge variant="secondary" className="bg-blue-100 text-blue-800">
                Auto-assign to Team Lead
              </Badge>
              <Badge
                variant="secondary"
                className="bg-green-100 text-green-800"
              >
                Maintenance Department
              </Badge>
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-500">
              Generation Rules
            </label>
            <p className="text-gray-900 font-medium mt-1">
              Generate SO 3 Days Before Due
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
